export default function () {

  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;



  const swiperContainers = `
    <div class="swiper-container">
        <div class="swiper-nav">
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next">More</div>
        </div>
        <div class="swiper-wrapper">
        </div>
    </div>
  `;


  // Slide Template
  function buildSlideTemplate(slide) {

    const title = `<h2>${slide.Title}</h2>`;

    const buttons = function (btn, btnText) {
      if (btn) {
        return `<a href="${btn}" class="swiper-button">${btnText}</a>`;
      } else {
        return '';
      }
    }

    let urlValidation = "";
    let buyValidation = "";

    if (slide.URL !== null) {
      urlValidation = `<a class="swiper-image-container swiper-lazy" href="${slide.URL}" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">`
    } else {
      urlValidation = `<p class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">`
    }

    if (slide.PurchaseURL !== null) {
      buyValidation = `<a href="${slide.PurchaseURL}" class="buyVipButton">Buy VIP</a>`
    } else {
      buyValidation = ``
    }


    const template = `
      <div class="swiper-slide">
        ${urlValidation}
          <div class="swiper-lazy-preloader"></div>
        </a>
        <div class="swiper-content-container">
          ${title}
          ${buttons(slide.URL, slide.DetailLinkText)}
          ${buyValidation}
        </div>
      </div>
    `;

    return template;
  }


  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);

    widgetData.forEach(function (slide, i) {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
    });

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      autoplay: {
        delay: 8000,
      },
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      a11y: true,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });

  }


  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
      // console.log(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });

}
